import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { CAMPAIGN_TYPE } from '../constants';
import SelectCampaignType from '../components/SelectCampaignType';
import { setCampaignType, unsetCustomerGroup } from '../actions';

const SelectCampaignTypeContainer = compose(
  connect(
    state => ({
      campaignType: state.engagement.campaign.type,
    }),
    { setCampaignType, unsetCustomerGroup },
  ),
  withHandlers({
    onClick: props => type => () => {
      props.setCampaignType(type);
      if (type === CAMPAIGN_TYPE.recurring) props.unsetCustomerGroup();
    },
  }),
)(SelectCampaignType);

export default SelectCampaignTypeContainer;
